import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { selectOrganizationsComparators } from '../organizationsManagementSelectors'
import { organizationsManagementActions } from '../organizationsManagementSagas'

const useComparatorIndex = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation('organizationManagement')
  const { isSelectraAdmin } = useSelector(selectAuthData)
  const comparators = useSelector(selectOrganizationsComparators)

  useEffect(() => {
    if (isSelectraAdmin) {
      dispatch({ type: organizationsManagementActions.LOAD_COMPARATORS })
    }
  }, [isSelectraAdmin])

  const handleAdd = () => navigate('/organisations/comparator/add')

  return { t, comparators, handleAdd, isSelectraAdmin }
}

export default useComparatorIndex
